/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  PUBLISH_CONSENTGID_AND_CONSENTINGGID_FOR_JOURNAL,
  CLEAR_JOURNAL_FORM,
  JOURNAL_DOCUMENT_SELECTED,
  FETCH_CONSENTING_JOURNAL_ERROR,
  FETCHED_CONSENTING_JOURNAL,
  FETCHING_CONSENTING_JOURNAL,
  FETCHING_JOURNAL_PDF,
  RECEIVE_JOURNAL_PDF,
  CLOSE_JOURNAL_PDF,
  ERROR_JOURNAL_PDF,
  FETCHING_PARTICIPANT_JOURNAL,
  FETCHED_PARTICIPANT_JOURNAL,
  FETCH_PARTICIPANT_JOURNAL_ERROR,
  RECEIVE_PARTICIPANT_JOURNAL_PDF,
  ERROR_PARTICIPANT_JOURNAL_PDF,
  FETCHING_PARTICIPANT_JOURNAL_PDF
} from '../actions/actionTypes';

const consentingJournalState = {
  consentGid: null,
  consentingGid: null,
  error: null,
  response: null,
  isFetching: false,
  isFetchingPdf: false
};

const consentingJournalReducer = (state = consentingJournalState, action) => {
  switch (action.type) {
    case PUBLISH_CONSENTGID_AND_CONSENTINGGID_FOR_JOURNAL:
      return Object.assign({}, state, {
        consentGid: action.payload.consentGid,
        consentingGid: action.payload.consentingGid
      });
    case CLEAR_JOURNAL_FORM:
      return Object.assign({}, state, consentingJournalState);
    case JOURNAL_DOCUMENT_SELECTED:
      return Object.assign({}, state, { consentingGid: action.payload });
    case FETCHING_CONSENTING_JOURNAL:
      return Object.assign({}, state, { isFetching: true, error: null, response: null });
    case FETCHED_CONSENTING_JOURNAL:
      return Object.assign({}, state, { isFetching: false, response: action.payload, error: null });
    case FETCH_CONSENTING_JOURNAL_ERROR:
      return Object.assign({}, state, { isFetching: false, error: action.payload });
    case FETCHING_JOURNAL_PDF:
      return Object.assign({}, state, { isFetchingPdf: true, error: null });
    case RECEIVE_JOURNAL_PDF:
      return Object.assign({}, state, { isFetchingPdf: false, error: null });
    case CLOSE_JOURNAL_PDF:
      return Object.assign({}, state, { isFetchingPdf: false });
    case ERROR_JOURNAL_PDF:
      return Object.assign({}, state, { isFetchingPdf: false, error: action.payload });
    case FETCHING_PARTICIPANT_JOURNAL:
      return Object.assign({}, state, { isFetching: true, error: null, response: null });
    case FETCHED_PARTICIPANT_JOURNAL:
      return Object.assign({}, state, { isFetching: false, response: action.payload, error: null });
    case FETCH_PARTICIPANT_JOURNAL_ERROR:
      return Object.assign({}, state, { isFetching: false, error: action.payload });
    case ERROR_PARTICIPANT_JOURNAL_PDF:
      return Object.assign({}, state, { isFetchingPdf: false, error: action.payload });
    case FETCHING_PARTICIPANT_JOURNAL_PDF:
      return Object.assign({}, state, { isFetchingPdf: true, error: null });
    case RECEIVE_PARTICIPANT_JOURNAL_PDF:
      return Object.assign({}, state, { isFetchingPdf: false, error: null });
    default:
      return state;
  }
};

export default consentingJournalReducer;
